import React, { useState, useCallback } from 'react';
import Cropper from 'react-easy-crop';
import { Modal, Button, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import getCroppedImg from '../../../utils/CropUtils';
import './ImageCropperModal.css'; // Estilos customizados

const ImageCropperModal = ({ show, handleClose, imageSrc, onCropComplete, aspect = 1, outputWidth = null, outputHeight = null }) => {
    const { t } = useTranslation();
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

    const onCropChange = (crop) => {
        setCrop(crop);
    };

    const onZoomChange = (zoom) => {
        setZoom(zoom);
    };

    const onCropCompleteCallback = useCallback((croppedArea, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels);
    }, []);

    const handleConfirm = async () => {
        try {
            const croppedImage = await getCroppedImg(imageSrc, croppedAreaPixels, 0, outputWidth, outputHeight);
            onCropComplete(croppedImage);
            handleClose();
        } catch (e) {
            console.error(e);
        }
    };

    return (
        <Modal show={show} onHide={handleClose} size="lg" centered backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>{t('crop_image')}</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ height: '400px', position: 'relative' }}>
                <div className="crop-container">
                    <Cropper
                        image={imageSrc}
                        crop={crop}
                        zoom={zoom}
                        aspect={aspect}
                        onCropChange={onCropChange}
                        onCropComplete={onCropCompleteCallback}
                        onZoomChange={onZoomChange}
                    />
                </div>
            </Modal.Body>
            <Modal.Footer className="justify-content-between">
                <div className="w-50">
                    <Form.Label>{t('zoom')}</Form.Label>
                    <Form.Range
                        value={zoom}
                        min={1}
                        max={3}
                        step={0.1}
                        onChange={(e) => setZoom(e.target.value)}
                    />
                </div>
                <div>
                    <Button variant="secondary" onClick={handleClose} className="me-2">
                        {t('cancel')}
                    </Button>
                    <Button variant="primary" onClick={handleConfirm}>
                        {t('confirm')}
                    </Button>
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export default ImageCropperModal;
